<template>
  <div>
    <div class="b-portlet">
      <div class="b-portlet-body">
        <div class="columns">
          <div class="column is-11" style="text-align: justify; text-justify: inter-word;">
            <content class="content" v-if="process.isProcessGroup">
              <h4>
                {{ process.processGroup.parentProcessGroup.name }} -
                {{ process.processGroup.name }}
              </h4>
              <!-- <p>Sabit aciklama yazisi gelecek</p> -->
              <article
                class="message is-light"
                v-for="processItem of process.processes"
                :key="processItem.id"
              >
                <div class="message-header" v-if="processItem.preliminaryText">
                  <p>{{ processItem.name }}</p>
                </div>
                <div
                  class="message-body"
                  v-if="processItem.preliminaryText"
                  v-html="processItem.preliminaryText"
                ></div>
              </article>
            </content>
            <content class="content" v-else>
              <p v-html="process.preliminaryText"></p>
            </content>
          </div>
          <div class="column">
            <div class="b-button-container">
              <button class="button is-primary is-pulled-right" @click="next">
                {{ $t('button.start') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['process'],
  methods: {
    next () {
      this.$emit('next')
    }
  }
}
</script>
